import { useEffect, useState } from "preact/hooks";
import { api } from "../api";
import { ExperienceCard, Notice, Spinner } from "../components";
import type { WalletPortfolio } from "../types";
import type { WalletState } from "../wallet";

export function PortfolioView(props: { wallet: WalletState; navigate(path: string): void }) {
  const [portfolio, setPortfolio] = useState<WalletPortfolio | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!props.wallet.account) {
      setPortfolio(null);
      return;
    }
    setLoading(true);
    setError(null);
    void api.portfolio(props.wallet.account)
      .then(setPortfolio)
      .catch((cause) => setError(cause instanceof Error ? cause.message : "Could not load Qyoos"))
      .finally(() => setLoading(false));
  }, [props.wallet.account]);

  return (
    <div class="page-shell portfolio-page">
      <header class="page-intro split-intro">
        <div><p class="eyebrow">Ethereum-owned, resolver-directed</p><h1>My Qyoos</h1><p>Everything this wallet owns or is trusted to control.</p></div>
        <button class="button primary" onClick={() => props.navigate("/mint")}>Mint another</button>
      </header>
      {!props.wallet.account && (
        <section class="empty-state"><span class="empty-orb" aria-hidden="true" /><h2>Connect your wallet</h2><p>Your wallet—not a Qyoo password—is how ownership is proven.</p><button class="button primary" onClick={() => void props.wallet.connect()}>Connect wallet</button></section>
      )}
      {loading && <Spinner label="Reading Registry ownership…" />}
      {error && <Notice kind="error">{error}. Ethereum ownership remains canonical; retry when the configured RPC is available.</Notice>}
      {portfolio && portfolio.qyoos.length === 0 && (
        <section class="empty-state"><span class="empty-orb" aria-hidden="true" /><h2>No Qyoos here yet</h2><p>Mint one, or ask an owner to delegate experience control to this wallet.</p><button class="button primary" onClick={() => props.navigate("/mint")}>Choose a Qyoo</button></section>
      )}
      {portfolio && portfolio.qyoos.length > 0 && (
        <section class="card-grid" aria-label="Wallet Qyoos">
          {portfolio.qyoos.map((entry) => <ExperienceCard key={entry.qyoo} entry={entry} onOpen={() => props.navigate(`/qyoo/${entry.qyoo}`)} />)}
        </section>
      )}
      {portfolio && <p class="source-note">Candidate events indexed through block {portfolio.indexedThroughBlock}; every role shown above was freshly verified against the Registry.</p>}
    </div>
  );
}
